import { Component } from '@angular/core';

import { RtmsType } from '@frontend/vanilla/core';
import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { ImageComponent } from '@frontend/vanilla/shared/image';

import { RtmsCtaActionComponent } from './rtms-cta-action.component';
import { RtmsLayerComponentBase } from './rtms-layer-component-base';

@Component({
    imports: [TrustAsHtmlPipe, RtmsCtaActionComponent, ImageComponent, IconCustomComponent],
    selector: 'lh-rtms-layer-overlay',
    templateUrl: 'rtms-layer-overlay.component.html',
})
export class RtmsLayerOverlayComponent extends RtmsLayerComponentBase {
    protected readonly RtmsType = RtmsType;
}
